import { render, staticRenderFns } from "./mobileWeifare.vue?vue&type=template&id=307573de&scoped=true&"
import script from "./mobileWeifare.vue?vue&type=script&lang=js&"
export * from "./mobileWeifare.vue?vue&type=script&lang=js&"
import style1 from "./mobileWeifare.vue?vue&type=style&index=1&id=307573de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307573de",
  null
  
)

export default component.exports